export const prefix = 'agri_app'

export const CACHEDEVICES = `${prefix}_cache_devices`
export const SELECTEDDEVICES = `${prefix}_selected_devices`
export const FAULTBILL = `${prefix}_fault_bill`
export const MAPSITE = `${prefix}_map_site`
export const USERINFO = `${prefix}_user_info`
export const USERADDRESS = `${prefix}_user_address`
export const POINTDETAILOPEN = `${prefix}_point_detail_open`
